import React from 'react';
import { Carousel } from 'react-responsive-carousel'
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import '../slider.css';

const TestimonialCarousel = ({ slider }) => {
  return(
    <Carousel 
    showThumbs={false}
    showStatus={false}
    showIndicators={false}
    autoPlay={true}
    infiniteLoop={true}
    className='w-full max-w-[1024px] flex items-center justify-center'
    >
      {slider.map((item, index) => {
        const {image, message, name} = item
        return (
        <div className='max-w-[840px] mx-auto lg:px-24 px-[70px] text-white'>
          <div className='text-lg mb-5 lg:text-xl leading-snug'>{message}</div>
          <div className='max-w-[70px] lg:max-w-[100px] mx-auto mb-3'>
            <img src={image} alt='avt' />
          </div>
          <div className='font-bold text-accent font-tertiary'>{name}</div>
        </div>
        );
      })}
    </Carousel>
  );
};

export default TestimonialCarousel;
